import { useState } from "react";
import styles from "./List.module.css";

export default function List({
    selectedService,
    selectedPhone,
    selectedTv,
    additionalOptions,
}) {
    const [serviceList, setServiceList] = useState([
        {
            name: "Internet",
            option: selectedService ? selectedService.name : 0,
        },
        {
            name: "Telefon",
            option:
                additionalOptions.find((el) => el.name === "Telefon").value ===
                0
                    ? 0
                    : `${
                          additionalOptions.find((el) => el.name === "Telefon")
                              .value
                      } kom`,
        },
        {
            name: "MojaTv",
            option:
                additionalOptions.find((el) => el.name === "MojaTV").value === 0
                    ? 0
                    : `${
                          additionalOptions.find((el) => el.name === "MojaTV")
                              .value
                      } kom`,
        },
    ]);

    return (
        <>
            {serviceList &&
                serviceList.length > 0 &&
                serviceList.reduce((sum, item) => sum + item.option, 0) !==
                    0 && (
                    <div className={styles.container}>
                        <div className={styles.title}>Odabrane usluge</div>

                        <div
                            className={styles[`service-label`]}
                            style={{
                                animationDelay: `1.1s`,
                            }}
                        >
                            <div className={styles[`service-name`]}>
                                Vrsta usluge
                            </div>
                            <div className={styles[`service-option`]}>
                                Naziv usluge
                            </div>
                        </div>
                        <div
                            className={styles.devider}
                            style={{
                                animationDelay: `1.2s`,
                            }}
                        />
                        <div className={styles.list}>
                            {serviceList.map((service, index) => {
                                return (
                                    service.option !== "" &&
                                    !/\b0\b/.test(service.option) && (
                                        <div key={index}>
                                            <div
                                                className={styles.service}
                                                style={{
                                                    animationDelay: `${
                                                        index * 0.2 + 1.3
                                                    }s`,
                                                }}
                                            >
                                                <div
                                                    className={
                                                        styles[`service-name`]
                                                    }
                                                >
                                                    {service.name}
                                                </div>
                                                <div
                                                    className={
                                                        styles[`service-option`]
                                                    }
                                                >
                                                    {service.option}
                                                </div>
                                            </div>
                                            <div
                                                className={styles.devider}
                                                style={{
                                                    animationDelay: `${
                                                        index * 0.2 + 1.4
                                                    }s`,
                                                }}
                                            />
                                        </div>
                                    )
                                );
                            })}
                        </div>
                    </div>
                )}
        </>
    );
}
